import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import TaskList from "@/components/TaskList";
import AISageTip from "@/components/AISageTip";
import { useLocation as useUserLocation } from "@/lib/useLocation";

const PLANNER_HEADER = "https://images.pexels.com/photos/5425794/pexels-photo-5425794.jpeg?auto=compress&w=1400&q=80";

export default function Planner() {
  const { location } = useUserLocation();

  return (
    <div className="space-y-8" data-testid="planner">
      <div
        className="relative rounded-lg overflow-hidden border border-border grain-overlay h-48 lg:h-56 bg-cover bg-center"
        style={{ backgroundImage: `url(${PLANNER_HEADER})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-transparent" />
        <div className="relative p-8 lg:p-10 max-w-lg h-full flex flex-col justify-end">
          <div className="label-overline">The grow planner</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-1">
            Daily, weekly, monthly.
          </h1>
        </div>
      </div>

      <Tabs defaultValue="daily" className="w-full">
        <TabsList className="bg-muted/60" data-testid="planner-tabs">
          <TabsTrigger value="daily" data-testid="tab-daily">Daily</TabsTrigger>
          <TabsTrigger value="weekly" data-testid="tab-weekly">Weekly</TabsTrigger>
          <TabsTrigger value="monthly" data-testid="tab-monthly">Monthly</TabsTrigger>
        </TabsList>

        <TabsContent value="daily" className="mt-6 space-y-6">
          <AISageTip scope="daily" location={location} />
          <TaskList scope="daily" title="Today's to-dos" />
        </TabsContent>

        <TabsContent value="weekly" className="mt-6 space-y-6">
          <AISageTip scope="weekly" location={location} />
          <TaskList scope="weekly" title="This week's plan" />
        </TabsContent>

        <TabsContent value="monthly" className="mt-6 space-y-6">
          <AISageTip scope="monthly" location={location} />
          <TaskList scope="monthly" title="This month's pacing" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
